import { makeStyles } from 'tss-react/mui';
import { useShallow } from 'zustand/react/shallow';
import useGeneralSettingsStore from '../../../../../../stores/GeneralSettings/useGeneralSettingsStore';
import { MediaFormatEnum } from '../../../../../general-settings/enums/mediaFormat.enum';
import ProductAvatarRenderer from '../../../../ProductAvatarRenderer';

interface CombinationItemImageProps {
  imageUrl?: string | null;
}

interface UseStylesProps {
  imageWidth?: number;
}

const useStyles = makeStyles<UseStylesProps>()((_, { imageWidth }) => ({
  imageContainer: {
    marginRight: 8,
    width: imageWidth ?? 38,
    minWidth: imageWidth ?? 38,
  },
}));

const CombinationItemImage = ({ imageUrl }: CombinationItemImageProps) => {
  const { mediaFormat } = useGeneralSettingsStore(
    useShallow((state) => ({
      mediaFormat: state.generalSettings.mediaFormat,
    })),
  );
  const { classes } = useStyles({
    imageWidth: mediaFormat === MediaFormatEnum.SQUARE ? 60 : 38,
  });

  return (
    <div className={classes.imageContainer}>
      <ProductAvatarRenderer url={imageUrl ?? undefined} />
    </div>
  );
};

export default CombinationItemImage;
